import { render, staticRenderFns } from "./NewPositionRecommendDialog.vue?vue&type=template&id=6b641b98&scoped=true&"
import script from "./NewPositionRecommendDialog.vue?vue&type=script&lang=js&"
export * from "./NewPositionRecommendDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewPositionRecommendDialog.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NewPositionRecommendDialog.vue?vue&type=style&index=1&id=6b641b98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b641b98",
  null
  
)

export default component.exports